import styled from 'styled-components';

export const AiProductsFormStyles = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const AiChatBox = styled.div`
  max-height: 300px;
  height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 576px) {
    height: 240px;
    max-height: 240px;
  }
`;

export const AiSidebarScroll = styled.div`
  height: 100%;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 992px) {
    max-height: 320px;
  }
`;

export const AiProductsListStyles = styled.div`
  .btn-to-quote {
    background-color: #00a651;
    cursor: pointer;
    color: #ffffff;
    transition: all 300ms ease-in-out;
    border: 1px solid #00a651;
  }

  .btn-to-quote a {
    color: #ffffff;
  }

  .btn-to-quote:hover a {
    color: #00a651;
  }

  .btn-to-quote:hover {
    background-color: transparent;
    color: #00a651;
    border: 1px solid #00a651;
  }

  .btn-to-quote-expired {
    background-color: #ffc107;
    cursor: pointer;
    color: #ffffff;
    transition: all 300ms ease-in-out;
    border: 1px solid #ffc107;
  }

  .btn-to-quote-expired a {
    color: #ffffff;
  }

  .btn-to-quote-expired:hover a {
    color: #ffc107;
  }

  .btn-to-quote-expired:hover {
    background-color: transparent;
    color: #ffc107;
    border: 1px solid #ffc107;
  }

  @media only screen and (min-width: 768px) {
    .quotation-filters {
      position: fixed;
      right: 0;
      top: 14.5%
    }
  }

  /* .search-input {
        width: 60%;
    }

    .search-plate {
        width: 20%;
    } */

  .search-input.form-control:focus,
  .search-plate.form-control:focus {
    box-shadow: 0 0 0 0.25rem rgb(0 166 81 / 25%) !important;
    border-color: rgb(0 166 81 / 50%) !important;
  }

  .search-btn {
    display: table;
    margin: 0 auto;
    width: 50%;
    border: 2px solid #00a651;
    background-color: #00a651;
    cursor: pointer;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    padding: 6px 16px;
  }

  @media (max-width: 576px) {
    .border,
    .rounded-3,
    .p-2,
    .d-flex,
    .align-items-end,
    .justify-content-center {
      max-height: 300px !important;
      height: 300px !important;
      overflow-y: visible !important;
    }
    .row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .col-12,
    .col-sm-12,
    .col-md-12,
    .col-lg-7,
    .col-xl-9,
    .col-lg-5,
    .col-xl-3 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
`;

export const SidebarCard = styled.div`
  border: 1px solid #e3e6ea;
  border-radius: 0.75rem;
  padding: 0.75rem;
  background-color: #fff;
  margin-bottom: 0.75rem;

  .sidebar-title {
    font-size: 0.9rem;
  }

  .sidebar-count {
    background-color: #f1f3f5;
    color: #495057;
    font-size: 0.72rem;
    font-weight: 600;
  }

  .sidebar-item {
    border: 1px solid #eef0f3;
    background-color: #fbfcfd;
    border-radius: 0.5rem;
    padding: 0.5rem 0.625rem;
    font-size: 0.85rem;
    line-height: 1.25;
  }

  .sidebar-empty {
    font-size: 0.8rem;
    color: #6c757d;
  }

  .attachment-row {
    border: 1px solid #eef0f3;
    background-color: #fbfcfd;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .attachment-row:hover {
    border-color: #00a651;
    box-shadow: 0 2px 6px rgba(0, 166, 81, 0.12);
  }

  .attachment-icon {
    color: #00a651;
  }

  .attachment-name {
    font-size: 0.875rem;
    line-height: 1.2;
  }

  .attachment-text {
    min-width: 0;
  }

  .attachment-hint {
    color: #00803e;
    font-size: 0.72rem;
    line-height: 1.15;
  }
`;
